import { Button, TextInput } from "@EMOrg-prd/react-standard";
import CodeBox from "./CodeBox";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useMsal } from "@azure/msal-react";
import { acquireAccessTokenInteractive } from "../modules/AuthUtilities";
import { useForm } from "../modules/FormContext";

const APIForm = () => {
  const { instance, accounts } = useMsal();
  const { clientId, scope, layer } = useForm();
  const [token, setToken] = useState("");
  const idp = layer === "experience" ? "Okta" : "Microsoft";

  const handleTokenRequest = useCallback(async () => {
    setToken("Requesting token...");

    const accessToken = await acquireAccessTokenInteractive(
      instance,
      accounts[0]
    );

    setTimeout(() => {
      setToken(accessToken);
    }, 500);
  }, [instance, accounts]);

  useEffect(() => {
    handleTokenRequest();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const requestBody = useMemo(
    () =>
      `{\n    "clientId": "${clientId}",\n    "scope": "${scope}",\n    "idp": "${idp}"\n}`,
    [clientId, scope, idp]
  );

  return (
    <>
      <TextInput
        label="Endpoint"
        value={process.env.REACT_APP_FUNCTION_APP_URL}
        readOnly
        style={{
          marginBottom: 0,
        }}
      />

      <CodeBox label="Request Body" value={requestBody}></CodeBox>
      <CodeBox label="Bearer Token" value={token}></CodeBox>

      <Button
        variant="primary"
        style={{
          width: "100%",
        }}
        onClick={async () => {
          await handleTokenRequest();
        }}
      >
        Refresh Token
      </Button>
    </>
  );
};

export default APIForm;
